export const CLOUD_PERIODS = [
  [1 / 60, "60s"],
  [5 / 60, "5min"],
  [10 / 60, "10min"],
  [30 / 60, "30min"],
  [1, "1h"],
  [6, "6h"],
  [24, "24h"],
  [168, "7d"],
];

export const cloudPeriodLabel = hours => CLOUD_PERIODS.find(([value]) => value === hours)?.[1] || `${hours}h`;

export const cloudTimeLabel = (value, hours) => new Date(value).toLocaleString("pt-BR", hours > 24
  ? { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }
  : { hour: "2-digit", minute: "2-digit", ...(hours <= 1 / 60 ? { second: "2-digit" } : {}) });
